module.exports = __webpack_public_path__ + "img/pdf_preview.2b90599c.svg";